import Enum from '../../utils/enum'

const VisibilityType = new Enum([
  'VISIBLE',
  'HIDDEN',
  'PRERENDER',
])

export default VisibilityType
